import { Component } from "@theme/component";

const SUPPORT_FIELD = "TICKET.support_ticket_type";
const TARGET_VALUES = ["I am interested in the SPA fountain", "Other"];
const CUSTOM_EVENT = "spafountain:contact_submit";

function classifyAudience(topic) {
  return TARGET_VALUES.indexOf(topic) !== -1 ? "target" : "exclude";
}

function readSupportTopicFromForm() {
  const frames = document.querySelectorAll(
    'iframe.hs-form-iframe, iframe[id^="hs-form-iframe"]'
  );
  for (let i = 0; i < frames.length; i++) {
    let doc = null;
    try {
      doc = frames[i].contentDocument;
    } catch (error) {
      doc = null;
    }
    if (!doc) continue;
    const select = doc.querySelector('select[name="' + SUPPORT_FIELD + '"]');
    if (select && select.value) return select.value;
  }
  return "";
}

function extractTopicFromEventData(data) {
  let entries = null;
  if (Array.isArray(data)) entries = data;
  else if (data && Array.isArray(data.submissionValues))
    entries = data.submissionValues;
  if (!entries) return "";
  for (let i = 0; i < entries.length; i++) {
    const field = entries[i];
    if (
      field &&
      typeof field.name === "string" &&
      field.name.indexOf("support_ticket_type") !== -1
    ) {
      return field.value || "";
    }
  }
  return "";
}

function publishContactSubmit(topic) {
  try {
    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === "function"
    ) {
      window.Shopify.analytics.publish(CUSTOM_EVENT, {
        support_topic: topic || "",
        audience: classifyAudience(topic),
      });
    }
  } catch (error) {
    // Tracking must never break the form submission.
  }
}

// Bridge HubSpot form submissions into the Shopify customer-events pipeline
// (where GTM lives, inside the custom pixel sandbox). Registered once.
if (typeof window !== "undefined" && !window.__spaHubspotBridge) {
  window.__spaHubspotBridge = true;
  let capturedTopic = "";

  window.addEventListener("message", (event) => {
    const data = event && event.data;
    if (!data || data.type !== "hsFormCallback") return;

    if (data.eventName === "onFormSubmit") {
      capturedTopic =
        extractTopicFromEventData(data.data) ||
        readSupportTopicFromForm() ||
        capturedTopic;
    } else if (data.eventName === "onFormSubmitted") {
      publishContactSubmit(capturedTopic || readSupportTopicFromForm());
      capturedTopic = "";
    }
  });
}

class HubspotFormComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initialize();
  }

  initialize() {
    if (this.dataset.initialized === "true") return;

    const portalId = this.dataset.portalId;
    const formId = this.dataset.formId;
    const region = this.dataset.region || "eu1";

    if (!portalId || !formId) return;

    const hasLibrary =
      typeof window !== "undefined" &&
      window.hbspt &&
      window.hbspt.forms &&
      typeof window.hbspt.forms.create === "function";

    if (hasLibrary) {
      this.dataset.initialized = "true";

      if (!this.id) {
        const explicitTargetId = this.dataset.targetId;
        this.id =
          explicitTargetId ||
          `hubspot-form-${Math.random().toString(36).slice(2)}`;
      }

      if (!window.hbspt || !window.hbspt.forms) {
        console.error(
          "Hubspot Forms library not found. Please ensure it is loaded."
        );
        return;
      }

      window.hbspt.forms.create({
        portalId,
        formId,
        region,
        target: `#${this.id}`,
      });

      return;
    }

    const previousAttempts = Number(this.dataset.retryCount || "0");
    if (previousAttempts > 20) return;

    this.dataset.retryCount = String(previousAttempts + 1);
    window.setTimeout(() => this.initialize(), 150);
  }
}

if (!customElements.get("hubspot-form-component")) {
  customElements.define("hubspot-form-component", HubspotFormComponent);
}
